// 一个vue3插件，用于注册全局使用的组件和指令
import Dialog from '@/components/dialog.vue'
import click from '@/plugins/vue/click'
import show from '@/plugins/vue/show'
import Image from '@/components/Image.vue'
import Icon from '../../components/icon.vue'

// 添加全局函数
import record from '@/utils/log'

const plugin = {
    install(app) {
        app.component('Dialog', Dialog)
        app.component('Image', Image)
        app.component('Icon', Icon)
        app.directive('click', click)
        app.directive('look', show)
        app.config.errorHandler = (err, instance, info) => {
            record({
                name: import.meta.env.VITE_NAME,
                message: err.message,
                stack: err.stack ? err.stack : '',
                instance: instance.$options.name,
                info
            })
        }
    }
}

export default plugin